module.exports = __webpack_public_path__ + "static/gowhip_soda-f5ba2a00c6f55b82fe1a232b700e491f.jpg";